import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * When the URL has a #hash and `ready` is true, scroll that element into view
 * and briefly highlight it. Use `ready` to wait until the target has rendered
 * (e.g. after data/tab loads).
 */
export function useHashScroll(ready = true) {
    const { hash } = useLocation();
    useEffect(() => {
        if (!ready || !hash) return;
        const id = decodeURIComponent(hash.slice(1));
        const el = document.getElementById(id);
        if (!el) return;
        const t = setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
            el.classList.add("hash-flash");
            setTimeout(() => el.classList.remove("hash-flash"), 2400);
        }, 150);
        return () => clearTimeout(t);
    }, [ready, hash]);
}
